import URLS from '@/server/urls';
import { GET } from '@/server/http';

export default async ({
    cate,
    group,
    type,
    count = -1,
}, options = { showError: true }) => {
    const [ content, error, status ] = await GET(URLS.sysApi.getList, {
        cate,
        group,
        type,
        count,
    }, options);
    if (error) return { error, status };
    return content || { rows: [] };
};
